import { Routes, Route } from 'react-router-dom';
import Main from '../general/js/Main';
import CustomBillPage from '../pages/CustomBills';
import AdditionalPackagePage from '../pages/AdditionalPackage/AdditionalPackage';
import ProtectedRoute from './ProtectedRoute';
import { HeaderSlotProvider } from '../context/HeaderSlotContext';
import ProductsPage from "../pages/Products/ProductsPage";

export default function AppRoutes() {
    return (
        <Routes>
            <Route
                element={
                    <HeaderSlotProvider>
                        <Main/>
                    </HeaderSlotProvider>
                }>
                <Route element={<ProtectedRoute/>}>
                    <Route path="bills/:billId?" element={<CustomBillPage/>}/>
                    <Route path="additional-package" element={<AdditionalPackagePage/>}/>
                </Route>
                <Route index element={<ProductsPage/>}/>
            </Route>
        </Routes>
    );
}
